import { Component, OnInit } from '@angular/core';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

    constructor(
        private readonly adobeLaunchService: AdobeLaunchService
    ) {
    }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Privacy Notice'
    });
  }

}
